import { Link, useInRouterContext } from 'react-router-dom'
import { FEE_CALCULATOR_PATH } from '../routes'

/** The disclaimer's words, for tests and anything that needs to match them. */
export const RESULTS_DISCLAIMER_TEXT =
  'Results are before trading fees. Fees depend on your exchange and tier — see what they do to these results in the fee calculator.'

/**
 * The one disclaimer shown wherever results appear (decided 2026-10-09):
 * every result a user sees is gross, before trading fees, and a user's own fee
 * is applied only in the fee calculator, which the last words link to. Shared
 * so the wording never forks; place it once per results area.
 */
const LINK_CLASS = 'font-medium text-sky-600 underline hover:text-sky-500 dark:text-sky-300'

const ResultsDisclaimer = ({ className = '' }: { className?: string }) => {
  // Some callers (the notification bell) also render outside a router; a
  // plain link keeps the disclaimer working there.
  const inRouter = useInRouterContext()
  return (
    <p className={`text-xs text-gray-500 dark:text-gray-400 ${className}`} data-testid="results-disclaimer">
      Results are before trading fees. Fees depend on your exchange and tier — see what they do to these results in the{' '}
      {inRouter ? (
        <Link to={FEE_CALCULATOR_PATH} className={LINK_CLASS}>
          fee calculator
        </Link>
      ) : (
        <a href={FEE_CALCULATOR_PATH} className={LINK_CLASS}>
          fee calculator
        </a>
      )}
      .
    </p>
  )
}

export default ResultsDisclaimer
